function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 8C15 9.06087 14.5786 10.0783 13.8284 10.8284C13.0783 11.5786 12.0609 12 11 12C9.93913 12 8.92172 11.5786 8.17157 10.8284C7.42143 10.0783 7 9.06087 7 8C7 6.93913 7.42143 5.92172 8.17157 5.17157C8.92172 4.42143 9.93913 4 11 4C12.0609 4 13.0783 4.42143 13.8284 5.17157C14.5786 5.92172 15 6.93913 15 8V8Z",
  stroke: "#334455",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 19.9998C4 18.1102 4.7375 16.2979 6.05025 14.9616C7.363 13.6254 9.14347 12.8748 11 12.8748",
  stroke: "#334455",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 13.5001C13 13.0001 12.8565 12.8748 11 12.8748",
  stroke: "#334455",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21 17.5C21 18.4283 20.6313 19.3185 19.9749 19.9749C19.3185 20.6313 18.4283 21 17.5 21C16.5717 21 15.6815 20.6313 15.0251 19.9749C14.3687 19.3185 14 18.4283 14 17.5C14 16.5717 14.3687 15.6815 15.0251 15.0251C15.6815 14.3687 16.5717 14 17.5 14C18.4283 14 19.3185 14.3687 19.9749 15.0251C20.6313 15.6815 21 16.5717 21 17.5Z",
  stroke: "#334455",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0117 17.6C17.0117 17.2686 17.2803 17 17.6117 17C17.9431 17 18.2117 17.2686 18.2117 17.6V18.9C18.2117 19.2314 17.9431 19.5 17.6117 19.5C17.2803 19.5 17.0117 19.2314 17.0117 18.9V17.6Z",
  fill: "#334455"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2 16.1C18.2 16.4314 17.9314 16.7 17.6 16.7C17.2687 16.7 17 16.4314 17 16.1C17 15.7686 17.2687 15.5 17.6 15.5C17.9314 15.5 18.2 15.7686 18.2 16.1Z",
  fill: "#334455"
});
const SvgAccountInfo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccountInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/account-info.b789fcb6.svg";
export { ForwardRef as ReactComponent };